import {
  presetFormats,
  allEvents,
} from "../../components/configurator/constants";
import {
  gamesTypes,
  typeIsGame,
} from "../../components/configurator/utils/utils";

const resetLayers = {
  north: { type: null },
  east: { type: null },
  south: { type: null },
  west: { type: null },
  middle: { type: null, rotation: null },
  event: { type: null },
  theme: {
    theme: null,
    song: null,
    title: "",
    description: "",
    loop: false,
    radius: 0,
    areaMode: "radius",
    scaleX: 1,
    scaleY: 1,
  },
  ground: { file: null, imageUrl: null, scale: 1, rotation: 0 },
  multiSelection: {
    active: false,
    isDelete: false,
    move: false,
    associateCoords: false,
    unlimited: false,
    x: 0,
    y: 0,
    tile: null,
    data: null,
    oldLayer: null,
    layer: null,
  },
  modalManager: {
    type: null,
    renderer: null,
    open: false,
    title: "",
    saveTrigger: false,
    lockAction: false,
    disableSave: true,
    orientation: null,
    disableGutters: false,
  },
  confirmation: {
    open: false,
    agree: undefined,
    element: null,
  },
  multiUpload: {
    active: false,
    files: [],
    activeFile: null,
  },
  wallsManagement: {
    orientation: "",
    color: { r: 0, g: 0, b: 0, a: 1 },
    mode: "add",
  },
};

const getOvKey = (type) => {
  if (type === "frame") return "frames";
  else if (type === "screen" || type === "ipad") return "screens";
  else if (type === "custom") return "customs";
  else return "misc";
};

const modifyGridSize = (
  grid,
  { mode, way, parentLayout, startingLineOrColumn },
  layouts
) => {
  let myGrid = { ...grid };
  const isGame = gamesTypes.includes(parentLayout);
  const columns = myGrid[parentLayout][0].length;
  const rows = myGrid[parentLayout].length;
  let i,
    tmp = [],
    lineChange,
    spawnIsDeleted = false,
    mainVideoDeleted = false;

  const tileContent = {
    north: { type: null },
    east: { type: null },
    south: { type: null },
    west: { type: null },
    middle: { type: null, rotation: null },
    event: { type: null },
    theme: {
      theme: null,
      song: null,
      title: "",
      description: "",
      loop: false,
      radius: 0,
      areaMode: "radius",
      scaleX: 1,
      scaleY: 1,
    },
    ground: { file: null, imageUrl: null, scale: 1, rotation: 0 },
    walls: {
      north: "empty",
      east: "empty",
      south: "empty",
      west: "empty",
    },
  };

  if (mode === "add") {
    if (way === "horizontal") {
      // add a row or several if basket
      if (!startingLineOrColumn) {
        for (i = 0; i < columns; i++)
          tmp.push({
            row: rows,
            column: i,
            ...tileContent,
          });
        myGrid[parentLayout].push(tmp);
      }
      if (isGame || startingLineOrColumn) {
        const tmpToSplice = [];
        for (i = 0; i < columns; i++)
          tmpToSplice.push({
            row: 0,
            column: i,
            ...tileContent,
          });
        myGrid[parentLayout].splice(0, 0, tmpToSplice);
        myGrid[parentLayout] = updateIndexes(myGrid[parentLayout], true, "row");
      }
      lineChange = {
        key: "rowNumber",
        value: startingLineOrColumn ? rows + 1 : isGame ? rows + 2 : rows + 1,
      };
    } else {
      // add a column
      if (!isGame && !startingLineOrColumn)
        grid[parentLayout].forEach((cGrid, index) => {
          cGrid.push({
            row: index,
            column: columns,
            ...tileContent,
          });
        });
      else {
        grid[parentLayout].forEach((cGrid, index) => {
          cGrid.splice(0, 0, {
            row: index,
            column: 0,
            ...tileContent,
          });
          if (isGame && !startingLineOrColumn) {
            cGrid.push({
              row: index,
              column: columns,
              ...tileContent,
            });
          }
        });
        myGrid[parentLayout] = updateIndexes(
          myGrid[parentLayout],
          true,
          "column"
        );
      }

      lineChange = {
        key: "columnNumber",
        value: startingLineOrColumn
          ? columns + 1
          : isGame
          ? columns + 2
          : columns + 1,
      };
    }
  } else {
    if (way === "horizontal") {
      // delete row
      let result;
      if (!startingLineOrColumn) {
        result = updateGridOnDeleteLines(
          grid,
          spawnIsDeleted,
          mainVideoDeleted,
          parentLayout,
          true, // isRow,
          rows,
          columns
        );
        myGrid = result.myGrid;
        spawnIsDeleted = result.spawnIsDeleted;
        mainVideoDeleted = result.mainVideoDeleted;
      }
      if (isGame || startingLineOrColumn) {
        result = updateGridOnDeleteLines(
          grid,
          spawnIsDeleted,
          mainVideoDeleted,
          parentLayout,
          true, // isRow,
          rows,
          columns,
          true
        );
        myGrid = result.myGrid;
        spawnIsDeleted = result.spawnIsDeleted;
        mainVideoDeleted = result.mainVideoDeleted;
        myGrid[parentLayout] = updateIndexes(
          myGrid[parentLayout],
          false,
          "row"
        );
      }
      lineChange = {
        key: "rowNumber",
        value: startingLineOrColumn ? rows - 1 : isGame ? rows - 2 : rows - 1,
      };
    } else {
      // delete column
      let result;
      if (!startingLineOrColumn) {
        result = updateGridOnDeleteLines(
          grid,
          spawnIsDeleted,
          mainVideoDeleted,
          parentLayout,
          false, // isRow,
          rows,
          columns
        );
        myGrid = result.myGrid;
        spawnIsDeleted = result.spawnIsDeleted;
        mainVideoDeleted = result.mainVideoDeleted;
      }
      if (isGame || startingLineOrColumn) {
        result = updateGridOnDeleteLines(
          grid,
          spawnIsDeleted,
          mainVideoDeleted,
          parentLayout,
          false, // isRow,
          rows,
          columns,
          true
        );
        myGrid = result.myGrid;
        spawnIsDeleted = result.spawnIsDeleted;
        mainVideoDeleted = result.mainVideoDeleted;
        myGrid[parentLayout] = updateIndexes(
          myGrid[parentLayout],
          false,
          "column"
        );
      }
      lineChange = {
        key: "columnNumber",
        value: startingLineOrColumn
          ? columns - 1
          : isGame
          ? columns - 2
          : columns - 1,
      };
    }
  }
  if (spawnIsDeleted) {
    let x,
      y,
      canBreak = false;
    for (x = 0; x < myGrid.default.length; x++) {
      y = 0;
      for (y = 0; y < myGrid.default[x].length; y++) {
        if (!myGrid.default[x][y].middle.type) {
          canBreak = true;
          myGrid.default[x][y].middle = {
            type: "spawn",
            rotation: "south",
            layout: "default",
            startTile: { row: x, column: y },
          };
          break;
        }
      }
      if (canBreak) break;
    }
  }
  const tmpLayouts = [...layouts];
  if (parentLayout !== "default") {
    const myIndex = tmpLayouts.findIndex((l) => l.name === parentLayout);
    const key = lineChange.key.includes("column") ? "column" : "row";
    tmpLayouts[myIndex] = { ...tmpLayouts[myIndex], [key]: lineChange.value };
  }
  return { grid: myGrid, lineChange, mainVideoDeleted, layouts: tmpLayouts };
};

const updateGridOnDeleteLines = (
  grid,
  spawnIsDeleted,
  mainVideoDeleted,
  parentLayout,
  isRow,
  rows,
  columns,
  isRemovingOrigin = false // true if remove line/row at pos 0
) => {
  let i, cpt;
  const breaker = isRow ? columns : rows;
  for (i = 0; i < breaker; i++) {
    const rowToCheck = isRemovingOrigin && isRow ? 0 : isRow ? rows - 1 : i;
    const columnToCheck =
      isRemovingOrigin && !isRow ? 0 : !isRow ? columns - 1 : i;
    const keys = Object.keys(
      grid[parentLayout][rowToCheck][columnToCheck]
    ).filter((key) => !["row", "column", "walls"].includes(key));
    for (cpt = 0; cpt < keys.length; cpt++) {
      if (grid[parentLayout][rowToCheck][columnToCheck][keys[cpt]].type) {
        if (
          grid[parentLayout][rowToCheck][columnToCheck][keys[cpt]].type ===
          "spawn"
        )
          spawnIsDeleted = true;
        if (
          (grid[parentLayout][rowToCheck][columnToCheck][keys[cpt]].type ===
            "ipad" ||
            grid[parentLayout][rowToCheck][columnToCheck][keys[cpt]].type ===
              "screen") &&
          grid[parentLayout][rowToCheck][columnToCheck][keys[cpt]].mainVideo
        )
          mainVideoDeleted = true;
        let myObj = {
          layer: keys[cpt],
          data: null,
          tile: grid[parentLayout][rowToCheck][columnToCheck][
            keys[cpt]
          ].hasOwnProperty("startTile")
            ? grid[parentLayout][rowToCheck][columnToCheck][keys[cpt]].startTile
            : {
                row: grid[parentLayout][rowToCheck][columnToCheck].row,
                column: grid[parentLayout][rowToCheck][columnToCheck].column,
              },
        };
        if (grid[parentLayout][rowToCheck][columnToCheck][keys[cpt]].endTile)
          myObj.tileEnd =
            grid[parentLayout][rowToCheck][columnToCheck][keys[cpt]].endTile;
        grid = updateObject(grid, parentLayout, myObj);
      }
    }
    if (!isRow) {
      if (!isRemovingOrigin) {
        grid[parentLayout][i].pop();
      } else {
        grid[parentLayout][i].shift();
      }
    }
  }
  if (isRow) {
    if (!isRemovingOrigin) {
      grid[parentLayout].pop();
    } else {
      grid[parentLayout].shift();
    }
  }
  return { myGrid: grid, spawnIsDeleted, mainVideoDeleted };
};

const updateObjectOverview = (grid) => {
  const tmp = {
    frames: [],
    screens: [],
    customs: [],
    misc: [],
  };
  Object.keys(grid).forEach((subGrid) => {
    grid[subGrid].forEach((myRow) => {
      myRow.forEach((tile) => {
        const keys = Object.keys(tile).filter(
          (key) => !["row", "column", "walls"].includes(key)
        );
        keys.forEach((key) => {
          const { startTile } = tile[key];
          if (tile[key].type) {
            let myObject = { type: tile[key].type };
            if (
              (startTile &&
                tile.row === startTile.row &&
                tile.column === startTile.column) ||
              !tile[key].hasOwnProperty("startTile")
            ) {
              myObject.row = tile.row;
              myObject.column = tile.column;
              myObject.layout = subGrid;
              myObject.imageUrl = tile[key].imageUrl || null;
              myObject.iconUrl = tile[key].iconUrl;
              myObject.previewUrl = tile[key].previewUrl;
              if (tile[key].file) myObject.file = tile[key].file;
              if (tile[key].hasOwnProperty("links"))
                myObject.links = tile[key].links;
              if (myObject.type === "custom" && tile[key].link) {
                myObject.link = tile[key].link;
              }
              // order objects overview
              tmp[getOvKey(tile[key].type)].push(myObject);
            }
          }
        });
      });
    });
  });
  return tmp;
};

const getPeer = (row, col, rowEnd, colEnd) => {
  if (col - colEnd === 1 && row === rowEnd) {
    return { start: "west", end: "east" };
  } else if (col - colEnd === -1 && row === rowEnd) {
    return { start: "east", end: "west" };
  } else if (row - rowEnd === 1 && col === colEnd) {
    return { start: "north", end: "south" };
  } else {
    return { start: "south", end: "north" };
  }
};

const removeSpawn = (grid) => {
  const myGrid = { ...grid };

  myGrid["default"].forEach((row) => {
    row.forEach((col) => {
      if (col?.middle?.type === "spawn") col.middle = resetLayers.middle;
    });
  });
  return myGrid;
};

const updateMySpawnWalls = (
  grid,
  layoutName,
  { tile, old, direction },
  gridSize
) => {
  let myGrid = { ...grid };
  if (old) {
    const oldSide =
      old === "top"
        ? "north"
        : old === "right"
        ? "east"
        : old === "bottom"
        ? "south"
        : "west";
    const oldOppositeSide =
      old === "top"
        ? "south"
        : old === "right"
        ? "west"
        : old === "bottom"
        ? "north"
        : "east";

    const oldNewRow =
      old === "top" ? tile.row - 1 : old === "bottom" ? tile.row + 1 : tile.row;
    const oldNewColumn =
      old === "right"
        ? tile.column + 1
        : old === "left"
        ? tile.column - 1
        : tile.column;

    myGrid[layoutName][tile.row][tile.column].walls[oldSide] = "empty";
    if (
      oldNewRow >= 0 &&
      oldNewColumn >= 0 &&
      oldNewRow <= gridSize.rowNumber - 1 &&
      oldNewColumn <= gridSize.columnNumber - 1
    )
      myGrid[layoutName][oldNewRow][oldNewColumn].walls[oldOppositeSide] =
        "empty";
  }
  if (direction) {
    const side =
      direction === "top"
        ? "north"
        : direction === "right"
        ? "east"
        : direction === "bottom"
        ? "south"
        : "west";
    const oppositeSide =
      direction === "top"
        ? "south"
        : direction === "right"
        ? "west"
        : direction === "bottom"
        ? "north"
        : "east";

    const newRow =
      direction === "top"
        ? tile.row - 1
        : direction === "bottom"
        ? tile.row + 1
        : tile.row;
    const newColumn =
      direction === "right"
        ? tile.column + 1
        : direction === "left"
        ? tile.column - 1
        : tile.column;

    myGrid[layoutName][tile.row][tile.column].walls[side] =
      old === direction ? "empty" : "none";
    if (
      newRow >= 0 &&
      newColumn >= 0 &&
      newRow <= gridSize.rowNumber - 1 &&
      newColumn <= gridSize.columnNumber - 1
    ) {
      myGrid[layoutName][newRow][newColumn].walls[oppositeSide] =
        old === direction ? "empty" : "none";
    }
  }

  return myGrid;
};

const updateObject = (
  grid,
  layoutName = "default",
  { layer, data, tile, tileEnd = null, wallsManagement = false, gridSize },
  collision = false
) => {
  const { row, column } = tile;
  let myGrid = { ...grid };

  const myData = data ? { ...data } : resetLayers[layer];

  if (!tileEnd) {
    if (
      !collision &&
      myData.type &&
      myGrid[layoutName][row][column][layer].type &&
      myGrid[layoutName][row][column][layer].hasOwnProperty("startTile") &&
      (myGrid[layoutName][row][column][layer].type !== myData.type ||
        (myGrid[layoutName][row][column][layer].type === myData.type &&
          (JSON.stringify(myGrid[layoutName][row][column][layer].startTile) !==
            JSON.stringify(myData.startTile) ||
            JSON.stringify(myGrid[layoutName][row][column][layer].endTile) !==
              JSON.stringify(myData.endTile))))
    )
      myGrid = updateObject(
        myGrid,
        layoutName,
        {
          layer,
          data: null,
          tile: myGrid[layoutName][row][column][layer].startTile,
          tileEnd: myGrid[layoutName][row][column][layer].endTile,
        },
        true
      );
    myGrid[layoutName][row][column][layer] = myData;
    if (wallsManagement)
      myGrid = updateMySpawnWalls(
        myGrid,
        layoutName,
        { tile: { row, column }, old: null, direction: myData.offset },
        gridSize
      );
  } else {
    const finalData = {
      ...myData,
      startTile: { row, column },
      endTile: { row: tileEnd.row, column: tileEnd.column },
    };
    let x = row > tileEnd.row ? tileEnd.row : row;
    let start = row < tileEnd.row ? tileEnd.row : row;

    let y = column < tileEnd.column ? column : tileEnd.column;
    let end = column > tileEnd.column ? column : tileEnd.column;
    for (x; x <= start; x++) {
      for (y; y <= end; y++) {
        if (
          !collision &&
          myData.type &&
          myGrid[layoutName][x][y][layer].type &&
          myGrid[layoutName][x][y][layer].hasOwnProperty("startTile") &&
          (myGrid[layoutName][x][y][layer].type !== myData.type ||
            (myGrid[layoutName][x][y][layer].type === myData.type &&
              (JSON.stringify(myGrid[layoutName][x][y][layer].startTile) !==
                JSON.stringify(myData.startTile) ||
                JSON.stringify(myGrid[layoutName][x][y][layer].endTile) !==
                  JSON.stringify(myData.endTile))))
        )
          myGrid = updateObject(
            myGrid,
            layoutName,
            {
              layer,
              data: null,
              tile: myGrid[layoutName][x][y][layer].startTile,
              tileEnd: myGrid[layoutName][x][y][layer].endTile,
            },
            true
          );
        myGrid[layoutName][x][y][layer] = data ? finalData : myData;
      }
      y = column < tileEnd.column ? column : tileEnd.column;
    }
  }
  return myGrid;
};

const addOrRemoveMultipleElements = (
  grid,
  layout,
  { tiles, layer, data = null }
) => {
  let myGrid = { ...grid };
  // if tile has startTile and endTile => remove the entire object
  if (tiles)
    tiles.forEach((tile) => {
      if (
        data?.type &&
        myGrid[layout][tile.row][tile.column][layer].type &&
        myGrid[layout][tile.row][tile.column][layer].hasOwnProperty(
          "startTile"
        ) &&
        (myGrid[layout][tile.row][tile.column][layer].type !== data.type ||
          (myGrid[layout][tile.row][tile.column][layer].type === data.type &&
            (JSON.stringify(
              myGrid[layout][tile.row][tile.column][layer].startTile
            ) !== JSON.stringify(data.startTile) ||
              JSON.stringify(
                myGrid[layout][tile.row][tile.column][layer].endTile
              ) !== JSON.stringify(data.endTile))))
      )
        myGrid = updateObject(
          myGrid,
          layout,
          {
            layer,
            data: null,
            tile: myGrid[layout][tile.row][tile.column][layer].startTile,
            tileEnd: myGrid[layout][tile.row][tile.column][layer].endTile,
          },
          true
        );
      myGrid[layout][tile.row][tile.column][layer] = data
        ? data
        : resetLayers[layer];
    });
  return myGrid;
};

const moveObject = (
  grid,
  {
    oldLayer,
    layer,
    data,
    tile,
    newTile,
    newTileStart = null,
    tileEnd = null,
    newTileEnd = null,
  },
  layout = "default"
) => {
  let myGrid = { ...grid };
  const { row, column } = tile;

  if (!tileEnd) {
    myGrid[layout][row][column][oldLayer] = resetLayers[oldLayer];
    myGrid[layout][newTile.row][newTile.column][layer] = { ...data };
  } else {
    myGrid = updateObject(myGrid, layout, { layer: oldLayer, tile, tileEnd });
    const finalData = {
      ...data,
      startTile: { row: newTileStart.row, column: newTileStart.column },
      endTile: { row: newTileEnd.row, column: newTileEnd.column },
    };
    myGrid = updateObject(myGrid, layout, {
      layer,
      data: finalData,
      tile: newTileStart,
      tileEnd: newTileEnd,
    });
  }
  return myGrid;
};

const getGridSize = (objects, walls) => {
  const gridValues = {
    rowNumber: 1,
    columnNumber: 1,
  };

  const objectRow = objects.reduce(
    (prev, current) => (prev > current.row ? prev : current.row),
    0
  );
  if (objectRow > gridValues.rowNumber) gridValues.rowNumber = objectRow;
  const objectColumn = objects.reduce(
    (prev, current) => (prev > current.column ? prev : current.column),
    0
  );
  if (objectColumn > gridValues.columnNumber)
    gridValues.columnNumber = objectColumn;
  const wallRow = walls.reduce(
    (prev, current) => (prev.row > current.row ? prev.row : current.row),
    0
  );
  if (wallRow > gridValues.rowNumber) gridValues.rowNumber = wallRow;
  const wallColumn = walls.reduce(
    (prev, current) => (prev > current.column ? prev : current.column),
    0
  );
  if (wallColumn > gridValues.columnNumber)
    gridValues.columnNumber = wallColumn;

  return {
    rowNumber: gridValues.rowNumber + 1,
    columnNumber: gridValues.columnNumber + 1,
  };
};

const multiGridGeneration = (rowNumber, columnNumber, layouts, objects) => {
  const tmpLayouts = [
    { name: "default", row: rowNumber, column: columnNumber },
    ...layouts,
  ];
  let grid = {};
  const parentedLayoutsList = {};
  objects.forEach((obj) => {
    if (
      obj.parentLayout &&
      !parentedLayoutsList.hasOwnProperty(obj.parentLayout)
    )
      parentedLayoutsList[obj.parentLayout] = [obj.layout];
  });
  tmpLayouts.forEach((layout) => {
    grid[layout.name] = Object.values(
      generateGrid(layout.row, layout.column, layout.name)
    )[0];
  });
  const selectorList = tmpLayouts.map((u) => ({
    label: u.name,
    value: u.name,
    key: u.name,
  }));

  return { grid, parentedLayoutsList, parentLayoutsList: selectorList };
};

const generateGrid = (
  rowNumber,
  columnNumber,
  layoutName = "default",
  format = null
) => {
  const defaultRows = rowNumber;
  const defaultColumns = columnNumber;
  let grid = [];
  for (let row = 0; row < defaultRows; row++) {
    let currentRow = [];
    for (let column = 0; column < defaultColumns; column++) {
      currentRow.push({
        row,
        column,
        north: { type: null },
        east: { type: null },
        south: { type: null },
        west: { type: null },
        middle: { type: null, rotation: null },
        event: { type: null },
        theme: {
          theme: null,
          song: null,
          title: "",
          description: "",
          loop: false,
          radius: 0,
          areaMode: "radius",
          scaleX: 1,
          scaleY: 1,
        },
        ground: { file: null, imageUrl: null, scale: 1, rotation: 0 },
        walls: {
          north: "empty",
          east: "empty",
          south: "empty",
          west: "empty",
        },
      });
    }
    grid.push(currentRow);
  }
  // if that's a predefined format triggered
  // add the elements from the predefined config
  if (format) {
    presetFormats[format].forEach((item) => {
      if (item.hasOwnProperty("startTile") && item.hasOwnProperty("endTile")) {
        grid[item.startTile.row][item.startTile.column][item.rotation] = item;
        grid[item.endTile.row][item.endTile.column][item.rotation] = item;
      } else {
        const { row, column, ...rest } = item;
        grid[row][column][item.rotation] = rest;
      }
    });
  }
  return { [layoutName]: grid };
};

const getPeerTileCoordinates = (row, column, peer) => {
  if (peer === "right") return { row, column: column + 1 };
  else if (peer === "left") return { row, column: column - 1 };
  else if (peer === "top") return { row: row - 1, column };
  else return { row: row + 1, column };
};

const getRotationAngleForGround = (rotation) => {
  switch (rotation) {
    case "north":
      return 0;
    case "east":
      return 90;
    case "south":
      return 180;
    case "west":
      return 270;
    default:
      return 0;
  }
};

const placeItemsInGrid = (grid, payload, gridSize) => {
  const { objects, themes, walls, noReload } = payload;
  let mainVideo = [];

  themes?.forEach((theme) => {
    const { row, column, ...rest } = theme;
    grid[theme.layout || "default"][theme.row][theme.column]["theme"] = {
      ...rest,
      song: theme.ambiantMusic || null,
      areaMode: theme.hasOwnProperty("scaleX") ? "scaled" : "radius",
      scaleX: theme.scaleX || 1,
      scaleY: theme.scaleY || 1,
    };
  });

  walls?.forEach((wall) => {
    grid[wall.layout || "default"][wall.row][wall.column].walls.north =
      wall.north
        ? { color: wall.north, orientation: "north", layout: wall.layout }
        : "empty";
    grid[wall.layout || "default"][wall.row][wall.column].walls.east = wall.east
      ? { color: wall.east, orientation: "east", layout: wall.layout }
      : "empty";
    grid[wall.layout || "default"][wall.row][wall.column].walls.south =
      wall.south
        ? { color: wall.south, orientation: "south", layout: wall.layout }
        : "empty";
    grid[wall.layout || "default"][wall.row][wall.column].walls.west = wall.west
      ? { color: wall.west, orientation: "west", layout: wall.layout }
      : "empty";
  });

  objects?.forEach((object) => {
    const isEvent = allEvents.includes(object.type);
    if (isEvent) {
      grid[object.layout || "default"][object.row][object.column]["event"] =
        object;
    } else {
      const { row, column, peer, rowEnd, columnEnd, ...left } = object;
      const startTile = { row, column };
      let endTile, layer;

      if (
        (peer && object.rotation) ||
        (object.rotation && object.size === "custom") ||
        (object.rotation &&
          ["frame", "screen", "socle", "designlogo", "fazlogo"].includes(
            object.type
          ))
      )
        layer = object.rotation;
      else if (object.type === "logo") layer = "ground";
      else layer = "middle";

      if (!rowEnd && !columnEnd && peer)
        endTile = getPeerTileCoordinates(row, column, peer);
      else if (!rowEnd && !columnEnd) endTile = null;
      else endTile = { row: rowEnd, column: columnEnd };

      let data = {
        ...left,
        type: object.type === "socle" ? "ipad" : object.type,
        startTile,
        layout: object.layout || "default",
      };
      if (noReload && layer === "ground") data.isLoaded = true;

      if (data.type === "frame" && data.previewUrl?.includes("blob:"))
        data.previewUrl = null;
      // backend doesn't send rotaton when rotation is 0, making slider crash and disable rerendering on change
      // so add rotation to 0 in the object
      if (object.type === "logo")
        data.rotation = getRotationAngleForGround(object.rotation);

      if (object.type === "custom" && !object.hasOwnProperty("interaction"))
        data.interaction = true;

      if (object.type === "screen" && data.contentType) delete data.contentType;

      if (endTile) data.endTile = endTile;

      if (peer) data.peer = getPeer(row, column, endTile.row, endTile.column);

      if (typeIsGame(object.type) && !object.hasOwnProperty("canFieldMove"))
        data.canFieldMove = false;

      if (
        object.type === "basket2" &&
        !object.hasOwnProperty("gameContentDuration")
      )
        data.gameContentDuration = 120;

      const finalData = {
        layer,
        data,
        tile: startTile,
      };
      if (endTile) finalData.tileEnd = endTile;

      if (object.mainVideo) mainVideo.push(finalData);

      if (object.type === "spawn") {
        finalData.wallsManagement = true;
        finalData.gridSize = gridSize;
      }
      grid = updateObject(grid, object.layout, finalData);
    }
  });
  return { grid, mainVideo };
};

const deleteWall = (grid, layout, { layer, data, tile }) => {
  let myGrid = { ...grid };

  myGrid[layout][tile.row][tile.column][layer][data.keyName] = "empty";
  return myGrid;
};

const formatKey = (key) => {
  return key.toLowerCase().replace(/\W/g, "");
};

const removeParentLayoutFromTile = (grid, key) => {
  return {
    ...grid,
    [key]: grid[key].map((row) =>
      row.map((tile) => {
        let tmp = { ...tile };
        const keys = Object.keys(tile).filter(
          (key) => !["row", "column"].includes(key)
        );
        keys.forEach((key) => {
          if (tmp[key].hasOwnProperty("parentLayout"))
            delete tmp[key].parentLayout;
        });
        return tmp;
      })
    ),
  };
};

const removeLayoutFromParentedList = (
  grid,
  parentedList,
  parentLayoutsList,
  myKey
) => {
  const tmp = { ...parentedList };
  const tmpGrid = { ...grid };
  let tmpList = [...parentLayoutsList];

  if (tmp[myKey]?.length > 0) {
    const childKey = tmp[myKey][0];
    delete tmp[childKey];
    delete tmpGrid[childKey];
    tmpList = tmpList.filter((lay) => lay.key !== childKey);
  }
  delete tmp[myKey];
  delete tmpGrid[myKey];
  tmpList = tmpList.filter((lay) => lay.key !== myKey);

  Object.keys(tmp).forEach((k) => {
    tmp[k] = tmp[k].filter((item) => item !== myKey);
  });
  return { grid: tmpGrid, parentedList: tmp, parentLayoutsList: tmpList };
};

const generateGameLayer = (grid, gameName, row = 21, column = 11) => {
  return { ...grid, ...generateGrid(row, column, gameName) };
};

const updateIndexes = (grid, add = false, mode) => {
  const updateIndex = add ? 1 : -1;
  return grid.map((row, rowIndex) =>
    row.map((tile, columnIndex) => {
      const tmp = {
        ...tile,
        row:
          mode !== "row"
            ? rowIndex
            : rowIndex === 0
            ? rowIndex
            : tile.row + updateIndex,
        column:
          mode !== "column"
            ? columnIndex
            : columnIndex === 0
            ? columnIndex
            : tile.column + updateIndex,
      };
      const keys = Object.keys(tile).filter(
        (key) => !["row", "column", "walls"].includes(key)
      );
      keys.forEach((key) => {
        if (tile[key].hasOwnProperty("startTile")) {
          tmp[key].startTile = {
            row:
              mode !== "row"
                ? tile[key].startTile.row
                : tile[key].startTile.row + updateIndex,
            column:
              mode !== "column"
                ? tile[key].startTile.column
                : tile[key].startTile.column + updateIndex,
          };
        }
        if (tile[key].hasOwnProperty("endTile")) {
          tmp[key].endTile = {
            row:
              mode !== "row"
                ? tile[key].endTile.row
                : tile[key].endTile.row + updateIndex,
            column:
              mode !== "column"
                ? tile[key].endTile.column
                : tile[key].endTile.column + updateIndex,
          };
        }
      });
      return tmp;
    })
  );
};

const updateObjectOverviewOnGameLayer = (
  objectsOverview,
  parentLayout,
  { mode, way, startingLineOrColumn }
) => {
  const isGame = gamesTypes.includes(parentLayout);
  if (!isGame && !startingLineOrColumn) return objectsOverview;
  else {
    const tmp = { ...objectsOverview };
    const positionModifier = mode === "add" ? 1 : -1;
    Object.keys(objectsOverview).forEach((key) => {
      objectsOverview[key].forEach((item, index) => {
        if (
          (startingLineOrColumn && item.layout === parentLayout) ||
          (isGame && gamesTypes.includes(item.layout))
        ) {
          tmp[key][index] = {
            ...item,
            row: way !== "horizontal" ? item.row : item.row + positionModifier,
            column:
              way !== "vertical" ? item.column : item.column + positionModifier,
          };
        }
      });
    });
    return tmp;
  }
};

const updateLastMainVideoArray = (lastMainVideo, parentedLayoutsList, data) => {
  const tmp = [...lastMainVideo];
  let matchingLayoutKey = null;
  Object.keys(parentedLayoutsList).forEach((key) => {
    if (parentedLayoutsList[key].includes(data.layout)) matchingLayoutKey = key;
  });
  const index = tmp.findIndex((item) => {
    return (
      item.layout === data.layout &&
      JSON.stringify(item.startTile) === JSON.stringify(data.startTile) &&
      JSON.stringify(item.endTile) === JSON.stringify(data.endTile)
    );
  });
  if (index < 0) {
    const filteredArray = tmp.filter((item) => {
      return (
        (matchingLayoutKey && item.layout !== matchingLayoutKey) ||
        (!matchingLayoutKey &&
          parentedLayoutsList.hasOwnProperty(data.layout) &&
          !parentedLayoutsList[data.layout].includes(item.layout)) ||
        (!matchingLayoutKey &&
          item.layout !== data.layout &&
          !parentedLayoutsList[data.layout]?.includes(item.layout))
      );
    });
    // check if that exist in parent or child layout and if yes remove
    filteredArray.push(data);
    lastMainVideo = filteredArray;
  } else {
    tmp.splice(index, 1);
    lastMainVideo = tmp;
  }
  return lastMainVideo;
};

export {
  updateObject,
  addOrRemoveMultipleElements,
  moveObject,
  resetLayers,
  getPeer,
  removeSpawn,
  generateGrid,
  multiGridGeneration,
  placeItemsInGrid,
  updateObjectOverview,
  modifyGridSize,
  updateMySpawnWalls,
  deleteWall,
  formatKey,
  removeLayoutFromParentedList,
  removeParentLayoutFromTile,
  generateGameLayer,
  updateObjectOverviewOnGameLayer,
  getGridSize,
  updateLastMainVideoArray,
};
